import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

export const useTenantPlan = () => {
  const {
    state: { tenancy },
  } = useGlobalContext();

  const currentPlanName = tenancy?.plan?.name;
  const currentPlanSlug = tenancy?.plan?.slug;

  const isInFreePlan =
    currentPlanSlug === "free" || currentPlanName?.includes("free");

  return {
    isInFreePlan,
  };
};
